import { CircularProgress } from "@mui/material"
import React from "react"
import defaultImg from "resources/images/default-preview.jpg"
import { FlexBox } from "ui/components/FlexBox"

interface IListPreviewProps {
  id: string | number
  width: number // in rem
  height: number // in rem
  url: string
  onClick?: (event: any) => any
}

export const ListPreview = React.memo(({ id, width, height, url, onClick }: IListPreviewProps) => {
  const [isLoading, setIsLoading] = React.useState(true)
  const [toUseUrl, setToUseUrl] = React.useState(url)
  const photoResizeTimeOut = React.useRef<any>(undefined)
  const parentId = `parent-${id}`
  const resizeImage = () => {
    clearTimeout(photoResizeTimeOut.current)
    photoResizeTimeOut.current = setTimeout(() => {
      const img = document.getElementById(`${id}`)
      if (!img) {
        return
      }
      const parent = document.getElementById(parentId)
      const parentHeight = parent?.offsetHeight || 0
      const screenMaxWidth = Math.max(parent?.offsetWidth || 0, 30)
      const screenMaxHeight = Math.max(parentHeight, 30)
      img.style.maxWidth = `${screenMaxWidth - 2}px`
      img.style.maxHeight = `${screenMaxHeight - 2}px`
    }, 250)
  }
  return (
    <FlexBox
      id={parentId}
      onClick={onClick}
      sx={{
        "width": `${width}rem`,
        "minWidth": `${width}rem`,
        "maxWidth": `${width}rem`,
        "height": `${height}rem`,
        "minHeight": `${height}rem`,
        "maxHeight": `${height}rem`,
        "cursor": onClick ? "pointer" : undefined,
        "& img.loading": {
          filter: "grayscale(1)"
        },
        "& .img": {
          maxWidth: `${width}rem`,
          maxHeight: `${height}rem`
        }
      }}>
      {isLoading && <CircularProgress size={`${height}rem`} />}
      <img
        id={`${id}`}
        className={`img ${isLoading ? "loading" : ""}`}
        src={toUseUrl}
        onLoad={() => {
          setIsLoading(false)
          resizeImage()
        }}
        onError={() => {
          setIsLoading(false)
          setToUseUrl(defaultImg)
        }}
      />
    </FlexBox>
  )
})
